"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.string.link.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _color = _interopRequireDefault(require("color"));

var _locales = require("@meepshop/locales");

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _link = _interopRequireWildcard(require("@meepshop/link"));

var _ItemNotFoundIcon = _interopRequireDefault(require("@meepshop/icons/lib/ItemNotFoundIcon"));

var _gqls = require("./gqls");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/productDiscontinued.less");

var styles = {
  "root": "store-refactor__productDiscontinued__root",
  "content": "store-refactor__productDiscontinued__content",
  "logo": "store-refactor__productDiscontinued__logo",
  "icon": "store-refactor__productDiscontinued__icon",
  "text": "store-refactor__productDiscontinued__text",
  "link": "store-refactor__productDiscontinued__link"
};

var ProductDiscontinued = function ProductDiscontinued() {
  var _data$viewer, _data$viewer$store, _data$viewer$store$lo, _data$viewer$store$lo2, _data$viewer$store$lo3;

  var _useTranslation = (0, _locales.useTranslation)('common'),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var router = (0, _link.useRouter)();

  var _useQuery = (0, _client.useQuery)(_gqls.getStoreLogo),
      data = _useQuery.data;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.logo
  }, data !== null && data !== void 0 && (_data$viewer = data.viewer) !== null && _data$viewer !== void 0 && (_data$viewer$store = _data$viewer.store) !== null && _data$viewer$store !== void 0 && (_data$viewer$store$lo = _data$viewer$store.logoImage) !== null && _data$viewer$store$lo !== void 0 && (_data$viewer$store$lo2 = _data$viewer$store$lo.scaledSrc) !== null && _data$viewer$store$lo2 !== void 0 && _data$viewer$store$lo2.w240 ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: "/"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: (_data$viewer$store$lo3 = data.viewer.store.logoImage.scaledSrc) === null || _data$viewer$store$lo3 === void 0 ? void 0 : _data$viewer$store$lo3.w240,
    alt: "item-not-found-logo"
  }))) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.content
  }, /*#__PURE__*/_react["default"].createElement(_ItemNotFoundIcon["default"], {
    className: styles.icon,
    style: {
      color: "".concat((0, _color["default"])(colors[3]).alpha(0.3))
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.text
  }, /*#__PURE__*/_react["default"].createElement("div", null, t('product-is-discontinued'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.link,
    onClick: function onClick() {
      router.push('/');
    }
  }, t('back-to-homepage'))), /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            .".concat(styles.root, " {\n              background-color: ").concat(colors[0], ";\n              color: ").concat(colors[3], ";\n            }\n\n            .").concat(styles.link, " {\n              color: ").concat(colors[2], ";\n              background-color: ").concat(colors[4], ";\n              box-shadow: 0 1px 5px 0 ").concat((0, _color["default"])(colors[2]).alpha(0.2), ";\n            }\n          ")
    }
  }));
};

var _default = ProductDiscontinued;
exports["default"] = _default;